import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#31493C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M20.167 9.992V3.758c0-1.375-.587-1.925-2.045-1.925H14.42c-1.457 0-2.044.55-2.044 1.925v6.234c0 1.375.587 1.925 2.044 1.925h3.703c1.458 0 2.045-.55 2.045-1.925ZM20.167 18.242v-1.65c0-1.375-.587-1.925-2.045-1.925H14.42c-1.457 0-2.044.55-2.044 1.925v1.65c0 1.375.587 1.925 2.044 1.925h3.703c1.458 0 2.045-.55 2.045-1.925ZM9.624 12.008v6.234c0 1.375-.587 1.925-2.044 1.925H3.876c-1.457 0-2.044-.55-2.044-1.925v-6.234c0-1.375.587-1.925 2.044-1.925H7.58c1.457 0 2.044.55 2.044 1.925ZM9.624 3.758v1.65c0 1.375-.587 1.925-2.044 1.925H3.876c-1.457 0-2.044-.55-2.044-1.925v-1.65c0-1.375.587-1.925 2.044-1.925H7.58c1.457 0 2.044.55 2.044 1.925Z"
    />
  </svg>
);
export default SvgComponent;
